import { render, staticRenderFns } from "./ConfirmPasswordChange.vue?vue&type=template&id=422e3ec6&scoped=true&"
import script from "./ConfirmPasswordChange.vue?vue&type=script&lang=js&"
export * from "./ConfirmPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPasswordChange.vue?vue&type=style&index=0&id=422e3ec6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e3ec6",
  null
  
)

export default component.exports